import React, { useEffect, useState } from 'react';
import { fetchSystemHealth, STATUS_COLOR } from '../lib/systemHealth';

// v1.6.67: small colored dot next to version badge that shows overall system health.
// Click to navigate to the full System Health page.
export default function SystemHealthDot({ onNavigate }) {
  const [status, setStatus] = useState('amber');
  const [tip, setTip] = useState('Checking system health…');

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const health = await fetchSystemHealth();
        if (cancelled) return;
        setStatus(health.overall);
        const failing = health.checks.filter((c) => c.status === 'red');
        const warn = health.checks.filter((c) => c.status === 'amber');
        if (failing.length) setTip(`Critical: ${failing.map((c) => c.label).join(' · ')}`);
        else if (warn.length) setTip(`Warnings: ${warn.map((c) => c.label).join(' · ')}`);
        else setTip('All systems normal');
      } catch (e) {
        if (cancelled) return;
        setStatus('amber');
        setTip('Health check unavailable');
      }
    }
    load();
    const t = setInterval(load, 60_000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  const color = STATUS_COLOR[status] || STATUS_COLOR.amber;

  return (
    <div
      onClick={() => onNavigate && onNavigate('system-health')}
      title={tip}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        cursor: 'pointer',
        userSelect: 'none',
      }}
    >
      <span style={{ width: 8, height: 8, borderRadius: '50%', background: color, boxShadow: `0 0 0 3px ${color}33` }} />
      <span style={{ fontSize: 10, color: '#8b9ab0', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 700 }}>
        {status === 'green' ? 'OK' : status === 'amber' ? 'WARN' : 'CRIT'}
      </span>
    </div>
  );
}
